import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { STORAGE_KEYS, TERMS_AND_CONDITIONS_PAGE } from '../app.constants';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class TermsGuard implements CanActivate {

  constructor(
    private router: Router,
    private readonly storageService: StorageService
  ) {
  }

  canActivate(next: any, state: RouterStateSnapshot): boolean {
    const hasAcceptedTermsAndConditions = this.storageService.get(STORAGE_KEYS.ACCEPTED_TERMS);

    // Verifica se os termos foram aceitos, se não, redireciona para a página de termos
    if (!hasAcceptedTermsAndConditions && state.url !== TERMS_AND_CONDITIONS_PAGE) {
      this.router.navigateByUrl(TERMS_AND_CONDITIONS_PAGE);
      return false;
    }

    return true;
  }
}
